export var TableSpacing;

(function (TableSpacing) {
  TableSpacing["Default"] = "default";
  TableSpacing["Reduced"] = "reduced";
})(TableSpacing || (TableSpacing = {}));

export var SortDirection;

(function (SortDirection) {
  SortDirection["None"] = "none";
  SortDirection["Ascending"] = "ascending";
  SortDirection["Descending"] = "descending";
})(SortDirection || (SortDirection = {}));

export var CellType;

(function (CellType) {
  CellType["Data"] = "Data";
  CellType["Header"] = "Header";
})(CellType || (CellType = {}));